import { FormNewsletter } from '@/components/common/FormNewsletter'
import { Splash } from '@/components/common/Splash'
import { SPLASHART } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import styles from './Newsletter.module.scss'

type Props = {
  contained?: boolean
}

export const Newsletter = ({ contained }: Props) => (
  <div className={cn(styles.container, { contained, styles })}>
    <Splash aspectRatio='4' backgroundImages={[SPLASHART.EDDIE_WIDE]} contrastNone />
    <div className={styles.content}>
      <h3>Want more Commander content, right in your inbox?</h3>
      <p>To stay on top of all our news, features, and deck techs, sign up for our EDHRECap e-mail newsletter.</p>
      <FormNewsletter />
    </div>
  </div>
)
